import React from 'react'
import { Container, Spinner } from 'react-bootstrap'

export default function LoadingPage() {
    return (
        <Container className='pt-5'>
            <div className='center '>
                <Spinner />
            </div>
        </Container>
    )
}
